/*
 *
 * Costs Actions
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 22-Apr-2025
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index'
// Import shop picker actions
import { doGetCostsShopList, doSetShopSelectionMode } from 'Store/actions/shopPicker'

export const actionTypes = {
  DO_DOWNLOAD_SELECTED_FILES: '@@Costs/download_selected_files',
  DO_GET_DISPUTE_TRANSACTION_DETAIL: '@@Costs/get_dispute_transaction_detail',
  DO_SHOP_SELECTOR_COST_INFO: '@@Costs/shop_selector_cost_info',
  // @generator action:route:type
  DO_SET_FROM_COMPENSATIONS: '@@Costs/set_from_compensations',
  DO_SET_DISPUTE_SELECTED: '@@Costs/set_dispute_selected',
  DO_GET_REFUNDS_DOWNLOAD: '@@Costs/get_refunds_download',
  DO_GET_COMPENSATION_DOWNLOAD: '@@Costs/get_compensation_download',
  DO_GET_COMPENSATION_DETAIL_DOWNLOAD: '@@Costs/get_compensation_detail_download',
  DO_GET_COST_TABS: '@@Costs/get_cost_tabs',
  DO_GET_CREDIT: '@@Costs/get_credit',
  DO_GET_DEBIT: '@@Costs/get_debit',
  DO_GET_START_DOWNLOAD_CREDIT: '@@Costs/get_start_download_credit',
  DO_GET_START_DOWNLOAD_DEBIT: '@@Costs/get_start_download_debit',
  DO_GET_START_DOWNLOAD_COMMISSIONS: '@@Costs/get_start_download_commissions',
  DO_POLLING_STATUS_DOWNLOAD_CREDIT: '@@Costs/polling_status_download_credit',
  DO_POLLING_STATUS_DOWNLOAD_DEBIT: '@@Costs/polling_status_download_debit',
  DO_POLLING_STATUS_DOWNLOAD_COMMISSIONS: '@@Costs/polling_status_download_commissions',
  DO_GET_DOWNLOAD_CREDIT: '@@Costs/get_download_credit',
  DO_GET_DOWNLOAD_DEBIT: '@@Costs/get_download_debit',
  DO_GET_DOWNLOAD_COMMISSIONS: '@@Costs/get_download_commissions',
  DO_GET_CREDIT_DETAILS: '@@Costs/get_credit_details',
  DO_GET_DEBIT_DETAILS: '@@Costs/get_debit_details',
  DO_GET_START_DOWNLOAD_CREDIT_DETAILS: '@@Costs/get_start_download_credit_details',
  DO_GET_START_DOWNLOAD_DEBIT_DETAILS: '@@Costs/get_start_download_debit_details',
  DO_POLLING_STATUS_DOWNLOAD_CREDIT_DETAILS: '@@Costs/polling_status_download_credit_details',
  DO_POLLING_STATUS_DOWNLOAD_DEBIT_DETAILS: '@@Costs/polling_status_download_debit_details',
  DO_GET_DOWNLOAD_CREDIT_DETAILS: '@@Costs/get_download_credit_details',
  DO_GET_DOWNLOAD_DEBIT_DETAILS: '@@Costs/get_download_debit_details',
  DO_SET_CREDIT_REQUEST_PARAMS: '@@Costs/set_credit_request_params',
  DO_SET_DEBIT_REQUEST_PARAMS: '@@Costs/set_debit_request_params',
  DO_SET_COMMISSION_REQUEST_PARAMS: '@@Costs/set_commission_request_params',
  DO_SET_RELOAD_CREDIT: '@@Costs/set_reload_credit',
  DO_SET_RELOAD_DEBIT: '@@Costs/set_reload_debit',
  DO_SET_RELOAD_COMMISSION: '@@Costs/set_reload_commission',
  DO_GET_SANCTIONS: '@@Costs/get_sanctions',
  DO_GET_DOWNLOAD_SANCTIONS: '@@Costs/get_download_sanctions',
  DO_GET_COMMISSIONS: '@@Costs/get_commissions',
  DO_GET_TOTAL: '@@Costs/get_total',
  DO_GET_OTHER_DEBIT_CREDIT: '@@Costs/get_other_debit_credit',
  DO_CHECK_SANCTIONS: '@@Costs/check_sanctions',
  DO_GET_ECONOMIC_CONDITIONS_DATA: '@@Costs/get_economic_conditions_data',
  DO_GET_ECONOMIC_CONDITIONS_OFFERS: '@@Costs/get_economic_conditions_offers',
  DO_GET_CONTRACT: '@@Costs/get_contract',
  DO_DOWNLOAD_ECONOMIC_CONDITIONS: '@@Costs/download_economic_conditions',
  DO_GET_CONTRACT_INFO: '@@Costs/get_contract_info',
  DO_SET_REFRESH_COSTS_CONTEXT: '@@Costs/set_refresh_costs_context',
  DO_GET_TECHNICAL: '@@Costs/get_technical',
  DO_SET_RELOAD_TECHNICAL: '@@Costs/set_reload_technical',
  DO_GET_TECHNICAL_FILTERS: '@@Costs/get_technical_filters',
  DO_RESET_TECHNICAL_FILTERS_ERROR: '@@Costs/reset_technical_filters_error',
  DO_SET_TECHNICAL_REQUEST_PARAMS: '@@Costs/set_technical_request_params',
  DO_GET_TECHNICAL_DETAILS: '@@Costs/get_technical_details',
  DO_DOWNLOAD_TECHNICAL_DETAILS: '@@Costs/download_technical_details',
  DO_DOWNLOAD_TECHNICAL: '@@Costs/download_technical',

  // @generator action:route:type:request
  ...createRequestTypes('@@Costs', 'GET_DISPUTE_TRANSACTION_DETAIL'),
  ...createRequestTypes('@@Costs', 'SHOP_SELECTOR_COST_INFO'),
  ...createRequestTypes('@@Costs', 'GET_REFUNDS_DOWNLOAD'),
  ...createRequestTypes('@@Costs', 'GET_COMPENSATION_DOWNLOAD'),
  ...createRequestTypes('@@Costs', 'GET_COMPENSATION_DETAIL_DOWNLOAD'),
  ...createRequestTypes('@@Costs', 'GET_COST_TABS'),
  ...createRequestTypes('@@Costs', 'GET_CREDIT'),
  ...createRequestTypes('@@Costs', 'GET_DEBIT'),
  ...createRequestTypes('@@Costs', 'GET_COMMISSIONS'),
  ...createRequestTypes('@@Costs', 'GET_TOTAL'),
  ...createRequestTypes('@@Costs', 'GET_OTHER_DEBIT_CREDIT'),
  ...createRequestTypes('@@Costs', 'CHECK_SANCTIONS'),
  ...createRequestTypes('@@Costs', 'GET_START_DOWNLOAD_CREDIT'),
  ...createRequestTypes('@@Costs', 'GET_START_DOWNLOAD_DEBIT'),
  ...createRequestTypes('@@Costs', 'GET_START_DOWNLOAD_COMMISSIONS'),
  ...createRequestTypes('@@Costs', 'POLLING_STATUS_DOWNLOAD_CREDIT'),
  ...createRequestTypes('@@Costs', 'POLLING_STATUS_DOWNLOAD_DEBIT'),
  ...createRequestTypes('@@Costs', 'POLLING_STATUS_DOWNLOAD_COMMISSIONS'),
  ...createRequestTypes('@@Costs', 'GET_DOWNLOAD_CREDIT'),
  ...createRequestTypes('@@Costs', 'GET_DOWNLOAD_DEBIT'),
  ...createRequestTypes('@@Costs', 'GET_DOWNLOAD_COMMISSIONS'),
  ...createRequestTypes('@@Costs', 'GET_CREDIT_DETAILS'),
  ...createRequestTypes('@@Costs', 'GET_DEBIT_DETAILS'),
  ...createRequestTypes('@@Costs', 'GET_START_DOWNLOAD_CREDIT_DETAILS'),
  ...createRequestTypes('@@Costs', 'GET_START_DOWNLOAD_DEBIT_DETAILS'),
  ...createRequestTypes('@@Costs', 'POLLING_STATUS_DOWNLOAD_CREDIT_DETAILS'),
  ...createRequestTypes('@@Costs', 'POLLING_STATUS_DOWNLOAD_DEBIT_DETAILS'),
  ...createRequestTypes('@@Costs', 'GET_DOWNLOAD_CREDIT_DETAILS'),
  ...createRequestTypes('@@Costs', 'GET_DOWNLOAD_DEBIT_DETAILS'),
  ...createRequestTypes('@@Costs', 'GET_SANCTIONS'),
  ...createRequestTypes('@@Costs', 'GET_DOWNLOAD_SANCTIONS'),
  ...createRequestTypes('@@Costs', 'GET_ECONOMIC_CONDITIONS_DATA'),
  ...createRequestTypes('@@Costs', 'GET_ECONOMIC_CONDITIONS_OFFERS'),
  ...createRequestTypes('@@Costs', 'GET_CONTRACT'),
  ...createRequestTypes('@@Costs', 'DOWNLOAD_ECONOMIC_CONDITIONS'),
  ...createRequestTypes('@@Costs', 'GET_CONTRACT_INFO'),
  ...createRequestTypes('@@Costs', 'GET_TECHNICAL'),
  ...createRequestTypes('@@Costs', 'GET_TECHNICAL_FILTERS'),
  ...createRequestTypes('@@Costs', 'GET_TECHNICAL_DETAILS'),
  ...createRequestTypes('@@Costs', 'DOWNLOAD_TECHNICAL_DETAILS'),
  ...createRequestTypes('@@Costs', 'DOWNLOAD_TECHNICAL')
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:route:request
/** @action request
* * Insert a description
* @name shopSelectorCostInfo
* @return {object} - The action object
*/
export const shopSelectorCostInfo = new MakeRequest('Costs', 'shop_selector_cost_info')
/** @action request
* * Insert a description
* @name getDisputeTransactionDetail
* @return {object} - The action object
*/
export const getDisputeTransactionDetail = new MakeRequest('Costs', 'get_dispute_transaction_detail')
/** @action request
* * Insert a description
* @name getCompensationDetailDownload
* @return {object} - The action object
*/
export const getCompensationDetailDownload = new MakeRequest('Costs', 'get_compensation_detail_download')
/** @action request
* * Insert a description
* @name getCompensationDownload
* @return {object} - The action object
*/
export const getCompensationDownload = new MakeRequest('Costs', 'get_compensation_download')
/** @action request
* * Insert a description
* @name getRefundsDownload
* @return {object} - The action object
*/
export const getRefundsDownload = new MakeRequest('Costs', 'get_refunds_download')
/** @action request
 * * Insert a description
 * @name getCostTabs
 * @return {object} - The action object
 */
export const getCostTabs = new MakeRequest('Costs', 'get_cost_tabs')
/** @action request
 * * Insert a description
 * @name getCredit
 * @return {object} - The action object
 */
export const getCredit = new MakeRequest('Costs', 'get_credit')
/** @action request
 * * Insert a description
 * @name getDebit
 * @return {object} - The action object
 */
export const getDebit = new MakeRequest('Costs', 'get_debit')
/** @action request
 * * Insert a description
 * @name getCommissions
 * @return {object} - The action object
 */
export const getCommissions = new MakeRequest('Costs', 'get_commissions')
/** @action request
 * * Insert a description
 * @name getTotal
 * @return {object} - The action object
 */
export const getTotal = new MakeRequest('Costs', 'get_total')
/** @action request
 * * Insert a description
 * @name getOtherDebitCredit
 * @return {object} - The action object
 */
export const getOtherDebitCredit = new MakeRequest('Costs', 'get_other_debit_credit')
/** @action request
 * * Insert a description
 * @name checkSanctions
 * @return {object} - The action object
 */
export const checkSanctions = new MakeRequest('Costs', 'check_sanctions')
/** @action request
 * * Insert a description
 * @name getStartDownloadCredit
 * @return {object} - The action object
 */
export const getStartDownloadCredit = new MakeRequest('Costs', 'get_start_download_credit')
/** @action request
 * * Insert a description
 * @name getStartDownloadDebit
 * @return {object} - The action object
 */
export const getStartDownloadDebit = new MakeRequest('Costs', 'get_start_download_debit')
/** @action request
 * * Insert a description
 * @name getStartDownloadCommission
 * @return {object} - The action object
 */
export const getStartDownloadCommissions = new MakeRequest('Costs', 'get_start_download_commissions')
/** @action request
 * * Insert a description
 * @name getPollingStatusDownloadCredit
 * @return {object} - The action object
 */
export const getPollingStatusDownloadCredit = new MakeRequest('Costs', 'polling_status_download_credit')
/** @action request
 * * Insert a description
 * @name getPollingStatusDownloadDebit
 * @return {object} - The action object
 */
export const getPollingStatusDownloadDebit = new MakeRequest('Costs', 'polling_status_download_debit')
/** @action request
 * * Insert a description
 * @name getPollingStatusDownloadCommissions
 * @return {object} - The action object
 */
export const getPollingStatusDownloadCommissions = new MakeRequest('Costs', 'polling_status_download_commissions')
/** @action request
 * * Insert a description
 * @name getDownloadCredit
 * @return {object} - The action object
 */
export const getDownloadCredit = new MakeRequest('Costs', 'get_download_credit')
/** @action request
 * * Insert a description
 * @name getDownloadDebit
 * @return {object} - The action object
 */
export const getDownloadDebit = new MakeRequest('Costs', 'get_download_debit')
/** @action request
 * * Insert a description
 * @name getDownloadCommissions
 * @return {object} - The action object
 */
export const getDownloadCommissions = new MakeRequest('Costs', 'get_download_commissions')
/** @action request
 * * Insert a description
 * @name getCreditDetails
 * @return {object} - The action object
 */
export const getCreditDetails = new MakeRequest('Costs', 'get_credit_details')
/** @action request
 * * Insert a description
 * @name getDebitDetails
 * @return {object} - The action object
 */
export const getDebitDetails = new MakeRequest('Costs', 'get_debit_details')
/** @action request
 * * Insert a description
 * @name getStartDownloadCreditDetails
 * @return {object} - The action object
 */
export const getStartDownloadCreditDetails = new MakeRequest('Costs', 'get_start_download_credit_details')
/** @action request
 * * Insert a description
 * @name getStartDownloadDebitDetails
 * @return {object} - The action object
 */
export const getStartDownloadDebitDetails = new MakeRequest('Costs', 'get_start_download_debit_details')
/** @action request
 * * Insert a description
 * @name getPollingStatusDownloadCreditDetails
 * @return {object} - The action object
 */
export const getPollingStatusDownloadCreditDetails = new MakeRequest('Costs', 'polling_status_download_credit_details')
/** @action request
 * * Insert a description
 * @name getPollingStatusDownloadDebitDetails
 * @return {object} - The action object
 */
export const getPollingStatusDownloadDebitDetails = new MakeRequest('Costs', 'polling_status_download_debit_details')
/** @action request
 * * Insert a description
 * @name getDownloadCreditDetails
 * @return {object} - The action object
 */
export const getDownloadCreditDetails = new MakeRequest('Costs', 'get_download_credit_details')
/** @action request
 * * Insert a description
 * @name getDownloadDebitDetails
 * @return {object} - The action object
 */
export const getDownloadDebitDetails = new MakeRequest('Costs', 'get_download_debit_details')

/** @action request
 * * The call to handle the details sanctions
 * @name getSanctions
 * @return {object} - The action object
 */

export const getSanctions = new MakeRequest('Costs', 'get_sanctions')
/** @action request
 * * Call to handle the download for sanctions excel
 * @name getDownloadSanctions
 * @return {object} - The action object
 */
export const getDownloadSanctions = new MakeRequest('Costs', 'get_download_sanctions')

/** @action request
 * * Set economic conditions
 * @name getEconomicConditionsData
 * @return {object} - The action object
 */
export const getEconomicConditionsData = new MakeRequest('Costs', 'get_economic_conditions_data')
/** @action request
 * * Set economic conditions
 * @name getEconomicConditionsOffers
 * @return {object} - The action object
 */
export const getEconomicConditionsOffers = new MakeRequest('Costs', 'get_economic_conditions_offers')
/** @action request
 * * Call to handle the download for sanctions excel
 * @name getContract
 * @return {object} - The action object
 */
export const getContract = new MakeRequest('Costs', 'get_contract')
/** @action request
 * * Call to handle the download for sanctions excel
 * @name downloadEconomicConditions
 * @return {object} - The action object
 */
export const downloadEconomicConditions = new MakeRequest('Costs', 'download_economic_conditions')
/** @action request
 * * Call to handle the more info for economic conditions
 * @name getContractInfo
 * @return {object} - The action object
 */
export const getContractInfo = new MakeRequest('Costs', 'get_contract_info')
/** @action request
 * * Insert a description
 * @name getTechnical
 * @return {object} - The action object
 */
export const getTechnical = new MakeRequest('Costs', 'get_technical')
/** @action request
 * * Insert a description
 * @name getTechnicalFilters
 * @return {object} - The action object
 */
export const getTechnicalFilters = new MakeRequest('Costs', 'get_technical_filters')
/** @action request
 * * Insert a description
 * @name getTechnicalDetails
 * @return {object} - The action object
 */
export const getTechnicalDetails = new MakeRequest('Costs', 'get_technical_details')
/** @action request
 * * Insert a description
 * @name downloadTechnical
 * @return {object} - The action object
 */
export const downloadTechnical = new MakeRequest('Costs', 'download_technical')
/** @action request
 * * Insert a description
 * @name downloadTechnicalDetails
 * @return {object} - The action object
 */
export const downloadTechnicalDetails = new MakeRequest('Costs', 'download_technical_details')

// ------------------------------------
// @generator action:route
/** @action
* * Insert a description
* @name ShopSelectorCostInfo
* @return {object} - The payload object
*/
export const doShopSelectorCostInfo = payload => createAction(actionTypes.DO_SHOP_SELECTOR_COST_INFO, { payload })
/** @action
* * Insert a description
* @name GetDisputeTransactionDetail
* @return {object} - The payload object
*/
export const doGetDisputeTransactionDetail = payload => createAction(actionTypes.DO_GET_DISPUTE_TRANSACTION_DETAIL, { payload })
/** @action
* * Insert a description
* @name DownloadSelectedFiles
* @return {object} - The payload object
*/
export const doDownloadSelectedFiles = payload => createAction(actionTypes.DO_DOWNLOAD_SELECTED_FILES, { payload })
/** @action
* * Insert a description
* @name GetCompensationDetailDownload
* @return {object} - The payload object
*/
export const doGetCompensationDetailDownload = payload => createAction(actionTypes.DO_GET_COMPENSATION_DETAIL_DOWNLOAD, { payload })
/** @action
* * Insert a description
* @name GetCompensationDownload
* @return {object} - The payload object
*/
export const doGetCompensationDownload = payload => createAction(actionTypes.DO_GET_COMPENSATION_DOWNLOAD, { payload })
/** @action
* * Insert a description
* @name GetRefundsDownload
* @return {object} - The payload object
*/
export const doGetRefundsDownload = payload => createAction(actionTypes.DO_GET_REFUNDS_DOWNLOAD, { payload })
/** @action
* * Insert a description
* @name SetDisputeSelected
* @return {object} - The payload object
*/
export const doSetDisputeSelected = payload => createAction(actionTypes.DO_SET_DISPUTE_SELECTED, { payload })
/** @action
* * Insert a description
* @name SetFromRefunds
* @return {object} - The payload object
*/
export const doSetFromCompensations = payload => createAction(actionTypes.DO_SET_FROM_COMPENSATIONS, { payload })
/** @action
 * * Insert a description
 * @name doGetCostTabs
 * @return {object} - The payload object
 */
export const doGetCostTabs = (payload) => createAction(actionTypes.DO_GET_COST_TABS, { payload })
/** @action
 * * Insert a description
 * @name doGetCredit
 * @return {object} - The payload object
 */
export const doGetCredit = (payload) => createAction(actionTypes.DO_GET_CREDIT, { payload })
/** @action
 * * Insert a description
 * @name doGetDebit
 * @return {object} - The payload object
 */
export const doGetDebit = (payload) => createAction(actionTypes.DO_GET_DEBIT, { payload })
/** @action
 * * Insert a description
 * @name doGetCommissions
 * @return {object} - The payload object
 */
export const doGetCommissions = (payload) => createAction(actionTypes.DO_GET_COMMISSIONS, { payload })
/** @action
 * * Insert a description
 * @name doGetTotal
 * @return {object} - The payload object
 */
export const doGetTotal = (payload) => createAction(actionTypes.DO_GET_TOTAL, { payload })
/** @action
 * * Insert a description
 * @name doGetOtherDebitCredit
 * @return {object} - The payload object
 */
export const doGetOtherDebitCredit = (payload) => createAction(actionTypes.DO_GET_OTHER_DEBIT_CREDIT, { payload })
/** @action
 * * Insert a description
 * @name doCheckSanctions
 * @return {object} - The payload object
 */
export const doCheckSanctions = (payload) => createAction(actionTypes.DO_CHECK_SANCTIONS, { payload })
/** @action
 * * Insert a description
 * @name doGetStartDownloadCredit
 * @return {object} - The payload object
 */
export const doGetStartDownloadCredit = (payload) => createAction(actionTypes.DO_GET_START_DOWNLOAD_CREDIT, { payload })
/** @action
 * * Insert a description
 * @name doGetStartDownloadDebit
 * @return {object} - The payload object
 */
export const doGetStartDownloadDebit = (payload) => createAction(actionTypes.DO_GET_START_DOWNLOAD_DEBIT, { payload })
/** @action
 * * Insert a description
 * @name doGetStartDownloadCommissions
 * @return {object} - The payload object
 */
export const doGetStartDownloadCommissions = (payload) => createAction(actionTypes.DO_GET_START_DOWNLOAD_COMMISSIONS, { payload })
/** @action
 * * Insert a description
 * @name doPollingStatusDownloadCredit
 * @return {object} - The payload object
 */
export const doPollingStatusDownloadCredit = (payload) => createAction(actionTypes.DO_POLLING_STATUS_DOWNLOAD_CREDIT, { payload })
/** @action
 * * Insert a description
 * @name doPollingStatusDownloadDebit
 * @return {object} - The payload object
 */
export const doPollingStatusDownloadDebit = (payload) => createAction(actionTypes.DO_POLLING_STATUS_DOWNLOAD_DEBIT, { payload })
/** @action
 * * Insert a description
 * @name doPollingStatusDownloadCommissions
 * @return {object} - The payload object
 */
export const doPollingStatusDownloadCommissions = (payload) => createAction(actionTypes.DO_POLLING_STATUS_DOWNLOAD_COMMISSIONS, { payload })
/** @action
 * * Insert a description
 * @name doGetDownloadCredit
 * @return {object} - The payload object
 */
export const doGetDownloadCredit = (payload) => createAction(actionTypes.DO_GET_DOWNLOAD_CREDIT, { payload })
/** @action
 * * Insert a description
 * @name doGetDownloadDebit
 * @return {object} - The payload object
 */
export const doGetDownloadDebit = (payload) => createAction(actionTypes.DO_GET_DOWNLOAD_DEBIT, { payload })
/** @action
 * * Insert a description
 * @name doGetDownloadCredit
 * @return {object} - The payload object
 */
export const doGetDownloadCommissions = (payload) => createAction(actionTypes.DO_GET_DOWNLOAD_COMMISSIONS, { payload })
/** @action
 * * Insert a description
 * @name doGetCreditDetails
 * @return {object} - The payload object
 */
export const doGetCreditDetails = (payload) => createAction(actionTypes.DO_GET_CREDIT_DETAILS, { payload })
/** @action
 * * Insert a description
 * @name doGetDebitDetails
 * @return {object} - The payload object
 */
export const doGetDebitDetails = (payload) => createAction(actionTypes.DO_GET_DEBIT_DETAILS, { payload })
/** @action
 * * Insert a description
 * @name doGetStartDownloadCreditDetails
 * @return {object} - The payload object
 */
export const doGetStartDownloadCreditDetails = (payload) => createAction(actionTypes.DO_GET_START_DOWNLOAD_CREDIT_DETAILS, { payload })
/** @action
 * * Insert a description
 * @name doGetStartDownloadDebitDetails
 * @return {object} - The payload object
 */
export const doGetStartDownloadDebitDetails = (payload) => createAction(actionTypes.DO_GET_START_DOWNLOAD_DEBIT_DETAILS, { payload })
/** @action
 * * Insert a description
 * @name doPollingStatusDownloadCreditDetails
 * @return {object} - The payload object
 */
export const doPollingStatusDownloadCreditDetails = (payload) => createAction(actionTypes.DO_POLLING_STATUS_DOWNLOAD_CREDIT_DETAILS, { payload })
/** @action
 * * Insert a description
 * @name doPollingStatusDownloadDebitDetails
 * @return {object} - The payload object
 */
export const doPollingStatusDownloadDebitDetails = (payload) => createAction(actionTypes.DO_POLLING_STATUS_DOWNLOAD_DEBIT_DETAILS, { payload })
/** @action
 * * Insert a description
 * @name doGetDownloadCreditDetails
 * @return {object} - The payload object
 */
export const doGetDownloadCreditDetails = (payload) => createAction(actionTypes.DO_GET_DOWNLOAD_CREDIT_DETAILS, { payload })
/** @action
 * * Insert a description
 * @name doGetDownloadDebitDetails
 * @return {object} - The payload object
 */
export const doGetDownloadDebitDetails = (payload) => createAction(actionTypes.DO_GET_DOWNLOAD_DEBIT_DETAILS, { payload })
/**
 * @action
 * * Set credit request parameters for transactions
 * @name doSetCreditRequestParams
 * @return {object} - The action object
 */
export const doSetCreditRequestParams = (payload) => createAction(actionTypes.DO_SET_CREDIT_REQUEST_PARAMS, { payload })
/**
 * @action
 * * Set debit request parameters for transactions
 * @name doSetDebitRequestParams
 * @return {object} - The action object
 */
export const doSetDebitRequestParams = (payload) => createAction(actionTypes.DO_SET_DEBIT_REQUEST_PARAMS, { payload })
/**
 * @action
 * * Set debit request parameters for transactions
 * @name doSetCommissionRequestParams
 * @return {object} - The action object
 */
export const doSetCommissionRequestParams = (payload) => createAction(actionTypes.DO_SET_COMMISSION_REQUEST_PARAMS, { payload })
/**
 * @action
 * * Set reload credit flag
 * @name doSetReloadCredit
 * @return {object} - The action object
 */
export const doSetReloadCredit = (payload) => createAction(actionTypes.DO_SET_RELOAD_CREDIT, { payload })
/**
 * @action
 * * Set reload credit flag
 * @name doSetReloadDebit
 * @return {object} - The action object
 */
export const doSetReloadDebit = (payload) => createAction(actionTypes.DO_SET_RELOAD_DEBIT, { payload })
/**
 * @action
 * * Set reload credit flag
 * @name doSetReloadCommission
 * @return {object} - The action object
 */
export const doSetReloadCommission = (payload) => createAction(actionTypes.DO_SET_RELOAD_COMMISSION, { payload })
/**
 * @action
 * * Set sanctions for details page
 * @name doGetSanctions
 * @return {object} - The action object
 */
export const doGetSanctions = (payload) => createAction(actionTypes.DO_GET_SANCTIONS, { payload })
/**
 * @action
 * * Set sanctions download
 * @name doGetDownloadSanctions
 * @return {object} - The action object
 */
export const doGetDownloadSanctions = (payload) => createAction(actionTypes.DO_GET_DOWNLOAD_SANCTIONS, { payload })
/** @action
 * * Set economic conditions
 * @name doGetEconomicConditionsData
 * @return {object} - The action object
 */
export const doGetEconomicConditionsData = (payload) => createAction(actionTypes.DO_GET_ECONOMIC_CONDITIONS_DATA, { payload })
/** @action
 * * Set economic conditions
 * @name doGetEconomicConditionsOffers
 * @return {object} - The action object
 */
export const doGetEconomicConditionsOffers = (payload) => createAction(actionTypes.DO_GET_ECONOMIC_CONDITIONS_OFFERS, { payload })
/**
 * @action
 * * Set sanctions download
 * @name doGetContract
 * @return {object} - The action object
 */
export const doGetContract = (payload) => createAction(actionTypes.DO_GET_CONTRACT, { payload })
/**
 * @action
 * * Get Economic Conditions download
 * @name doDownloadEconomicConditions
 * @return {object} - The action object
 */
export const doDownloadEconomicConditions = (payload) => createAction(actionTypes.DO_DOWNLOAD_ECONOMIC_CONDITIONS, { payload })
/**
 * @action
 * * Get Economic Conditions More Info
 * @name doGetContractInfo
 * @return {object} - The action object
 */
export const doGetContractInfo = (payload) => createAction(actionTypes.DO_GET_CONTRACT_INFO, { payload })

/**
 * @action
 * * Set refresh costs context flag and active tab
 * @name doSetRefreshCostsContext
 * @return {object} - The action object
 */
export const doSetRefreshCostsContext = (payload) => createAction(actionTypes.DO_SET_REFRESH_COSTS_CONTEXT, { payload })

// Export shop picker actions
export { doGetCostsShopList, doSetShopSelectionMode }
/** @action
 * * Insert a description
 * @name doGetTechnical
 * @return {object} - The payload object
 */
export const doGetTechnical = (payload) => createAction(actionTypes.DO_GET_TECHNICAL, { payload })
/**
 * @action
 * * Set Technical request parameters
 * @name doSeTechnicalRequestParams
 * @return {object} - The action object
 */
export const doSetTechnicalRequestParams = (payload) => createAction(actionTypes.DO_SET_TECHNICAL_REQUEST_PARAMS, { payload })
/**
 * @action
 * * Set reload technical flag
 * @name doSetReloadTechnical
 * @return {object} - The action object
 */
export const doSetReloadTechnical = (payload) => createAction(actionTypes.DO_SET_RELOAD_TECHNICAL, { payload })
/**
 * @action
 * * Insert a description
 * @name doGetTechnicalFilters
 * @return {object} - The action object
 */
export const doGetTechnicalFilters = (payload) => createAction(actionTypes.DO_GET_TECHNICAL_FILTERS, { payload })
/**
 * @action
 * * Insert a description
 * @name doResetTechnicalFiltersError
 * @return {object} - The action object
 */
export const doResetTechnicalFiltersError = (payload) => createAction(actionTypes.DO_RESET_TECHNICAL_FILTERS_ERROR, { payload })
/** @action
 * * Insert a description
 * @name doGetTechnicalDetails
 * @return {object} - The action object
 */
export const doGetTechnicalDetails = (payload) => createAction(actionTypes.DO_GET_TECHNICAL_DETAILS, { payload })
/** @action
 * * Insert a description
 * @name doDownloadTechnical
 * @return {object} - The action object
 */
export const doDownloadTechnical = (payload) => createAction(actionTypes.DO_DOWNLOAD_TECHNICAL, { payload })
/** @action
 * * Insert a description
 * @name doDownloadTechnicalDetails
 * @return {object} - The action object
 */
export const doDownloadTechnicalDetails = (payload) => createAction(actionTypes.DO_DOWNLOAD_TECHNICAL_DETAILS, { payload })
